module.exports = __webpack_public_path__ + "img/hangsengbank.a24f0d0e.jpg";